const setFilterRoleName = (name: string) => ({
  type: 'SET_FILTER_ROLE_NAME',
  name,
})

export default setFilterRoleName
